import { Injectable } from '@angular/core';
import { DecodedToken, OauthAEMConfig } from '@com-delta-idp/mnx-oauth';
import { jwtDecode } from 'jwt-decode';
import {
  LOGIN_PAGE_ROUTES,
  STANDALONE_PAGE_URL,
  VIEW_NAME
} from '../constants/login-constant';
import { loginAndGetDashboardResponse } from '../models/login-authentication-screen.interface';
import { PingLoginAdapterSupportService } from './ping-login-adapter-support.service';

@Injectable({
  providedIn: 'root'
})
export class AddLoginInfoAdapterRedirectService extends PingLoginAdapterSupportService {
  isStandalone = false;
  awsFlowEnabled = false;

  constructor() {
    super();
  }

  redirectToEmail(
    response: loginAndGetDashboardResponse,
    tokenResponse?: string
  ): void {
    if (this.validEmail(response)) {
      this.loginUtilHelperService.tokenResponse = tokenResponse || '';
      this.redirectBasedOnPosition(
        LOGIN_PAGE_ROUTES.ADD_EMAIL_ROUTE,
        VIEW_NAME.ADD_EMAIL_ADDRESS_SCREEN
      );
    }
  }

  redirectSQA(response: loginAndGetDashboardResponse): void {
    if (!response.hasSQA) {
      if (this.awsFlowEnabled) {
        this.addSqaFacadeService.getAddSqaPageContent();
      }
      this.redirectBasedOnPosition(
        LOGIN_PAGE_ROUTES.ADD_SQA_ROUTE,
        VIEW_NAME.ADD_SECURITY_QUESTION_ANS_SCREEN
      );
    }
  }

  redirectBasedOnPosition(redirectUrl: string, redirectToView: string): void {
    if (this.awsFlowEnabled) {
      this.isStandalone === false
        ? this.nextDisplayService.nextDisplayView(redirectToView)
        : this.router.navigateByUrl(`/${STANDALONE_PAGE_URL[redirectToView]}`);
    } else {
      window.location.replace(redirectUrl);
    }
  }

  validEmail(response: loginAndGetDashboardResponse): boolean {
    return !response.hasEmail || !response.isEmailValid;
  }

  checkForRedirectUrl(
    refreshUrlFromQueryParams: string,
    authenticationConfig?: OauthAEMConfig
  ) {
    const redirectRefreshUrl =
      authenticationConfig?.REDIRECT_REFRESH_URLS ?? [];
    this.redirectRefreshUrlCheck =
      redirectRefreshUrl.some((item) =>
        refreshUrlFromQueryParams.includes(item)
      ) ?? false;
  }

  checkMfaFlowSQA(
    response: loginAndGetDashboardResponse,
    authenticationConfig?: OauthAEMConfig
  ): boolean {
    if (!response.hasSQA) {
      if (
        authenticationConfig?.MFA_FLOW ||
        authenticationConfig?.DISABLE_SQA_SCREEN
      ) {
        return true;
      }
      return false;
    }
    return true;
  }

  decodeMDC(tokenResponse?: string): boolean {
    if (tokenResponse) {
      const decoded: DecodedToken = jwtDecode(tokenResponse);
      if (this.checkMdc(decoded)) {
        return true;
      }
      return false;
    }
    return false;
  }

  checkMdc(decoded: DecodedToken) {
    return decoded && decoded.mdc && decoded.mdc > 0;
  }
}
